import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TourService as CoreTourService, UI_TOUR_OPTIONS } from 'ngx-ui-tour-core';
import { Tour } from './tour';
import { TourStepTemplateRegistry } from './tour-step-template-registry';
import type { IStepOption } from './step-option';

export function provideUiTour(config: IStepOption = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    // The backdrop sits above the live page's layers (up to 900); the step opens in the browser's top layer.
    { provide: UI_TOUR_OPTIONS, useValue: { showArrow: true, backdropConfig: { zIndex: '999' }, ...config } },
    Tour,
    { provide: CoreTourService, useExisting: Tour },
    TourStepTemplateRegistry,
  ]);
}
